// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"89ca6f5c","561":"89ca6f5c","778":"89ca6f5c"}[chunkId] + ".chunk.css";
};